export const checkIfOrderSentToWarehouse = (date) => {
	if (date === "0001-01-01 00:00" || date === "0001-01-01T00:00:00Z" || date === null || date === "" || date === undefined) {
		return (
			false
		);
	} else {
		return (
			true
		);
	}
};

// Courier statuses kept in the API catalogue but no longer offered in the Order
// Status filter (BEZ-5772). Rows may still display these labels if present on
// an order; they are only hidden from the dropdown.
const HIDDEN_COURIER_STATUS_FILTERS = new Set([
	"notscanned",
	"awaitingscan",
	"returningtosender",
	"lostintransit",
	"lostnotscanned",
	"availableforcustomercollection",
	"availableforpickup",
]);

export const filterCourierStatusesForDropdown = (statuses = []) =>
	statuses.filter((status) => !HIDDEN_COURIER_STATUS_FILTERS.has(status?.name));

